<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">日期</label>
            <em class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.had_time}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <span class="weui-form-preview__value">{{initData.had_emname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">部门</label>
            <span class="weui-form-preview__value">{{initData.had_deptname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">职务</label>
            <span class="weui-form-preview__value">{{initData.had_ex_job}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">所属规则</label>
            <span class="weui-form-preview__value">{{initData.had_cr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">所属规则名称</label>
            <span class="weui-form-preview__value">{{initData.had_cr_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">校准状态</label>
            <span class="weui-form-preview__value">{{initData.had_status}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">班次</label>
            <span class="weui-form-preview__value">{{initData.had_class}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">标准工作时长</label>
            <span class="weui-form-preview__value">{{initData.had_standa_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">实际工作时长</label>
            <span class="weui-form-preview__value">{{initData.had_actual_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">旷工（天）</label>
            <span class="weui-form-preview__value">{{initData.had_absenteeism_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">旷工（次数）</label>
            <span class="weui-form-preview__value">{{initData.had_absenteeism_count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">迟到（分钟）</label>
            <span class="weui-form-preview__value">{{initData.had_late_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">迟到（次数）</label>
            <span class="weui-form-preview__value">{{initData.had_late_count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">早退（分钟）</label>
            <span class="weui-form-preview__value">{{initData.had_leave_early_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">早退（次数）</label>
            <span class="weui-form-preview__value">{{initData.had_leave_early_count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年假</label>
            <span class="weui-form-preview__value">{{initData.had_annual_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">外出</label>
            <span class="weui-form-preview__value">{{initData.had_outcat_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出差</label>
            <span class="weui-form-preview__value">{{initData.had_business}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">事假</label>
            <span class="weui-form-preview__value">{{initData.had_matter_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">病假（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_sick_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">调休假（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_exchange_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">婚假（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_marry_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产假（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_maternity_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">陪产假（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_paternity_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">其他（天）</label>
            <span class="weui-form-preview__value">{{initData.had_other_day}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">丧假（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_funeral_hour}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">春节必休（小时）</label>
            <span class="weui-form-preview__value">{{initData.had_newyear_hour}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">加班时长</label>
            <span class="weui-form-preview__value">{{initData.had_ot_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作日（调休）</label>
            <span class="weui-form-preview__value">{{initData.had_ot_exchange}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作日（加班费）</label>
            <span class="weui-form-preview__value">{{initData.had_ot_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">休息日（调休）</label>
            <span class="weui-form-preview__value">{{initData.had_rest_ot_exchange}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">休息日（加班费）</label>
            <span class="weui-form-preview__value">{{initData.had_rest_ot_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">节假日（调休）</label>
            <span class="weui-form-preview__value">{{initData.had_holiday_ot_exchange}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">节假日（加班费）</label>
            <span class="weui-form-preview__value">{{initData.had_holiday_ot_pay}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上班打卡1</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_start1}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_start_status1}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下班打卡1</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_end1}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_end_status1}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上班打卡2</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_start2}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_start_status2}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下班打卡2</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_end2}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_end_status2}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上班打卡3</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_start3}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_start_status3}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下班打卡3</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_end3}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_end_status3}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上班打卡4</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_start4}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_start_status4}}</span>
          </div>          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下班打卡4</label>
            <span class="weui-form-preview__value">{{initData.had_checkInTime_end4}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{initData.had_worktime_end_status4}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{initData.had_remarks}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    initData: Object
  }
}
</script>